import { Observable, catchError, throwError } from 'rxjs';

export class ImageProcessingAlgorithms {
  static dataURLtoBlob(dataUrl: string): Blob {
    const arr = dataUrl.split(',');
    // Extract the MIME type
    const mimeMatch = arr[0].match(/:(.*?);/);

    if (!mimeMatch) {
      throw new Error('Invalid data URL: MIME type not found');
    }

    const mime = mimeMatch[1];
    const bstr = atob(arr[1]);

    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }

  static blobToDataURL(blob: Blob, callback: (dataUrl: string) => void) {
    const a = new FileReader();
    a.onload = (e: any) => {
      callback(e.target.result);
    };
    a.readAsDataURL(blob);
  }

  static getNewImageDimensions(
    file: string,
    maxSize: number,
  ): Observable<{ width: number; height: number } | undefined> {
    return new Observable((observer) => {
      if (!file) {
        observer.error('No file.');
      }

      this.getImageDimensions(file)
        .pipe(
          catchError((err) => {
            observer.error('Failed to get image dimensions.');
            return throwError(() => err);
          }),
        )
        .subscribe((dimensionsNatural) => {
          const dimensions = this.calculateDimensions(dimensionsNatural, maxSize);
          if (!dimensions) {
            observer.error('No dimensions.');
          }
          observer.next(dimensions);
        });
    });
  }

  static getImageDimensions(file: string): Observable<{ width: number; height: number }> {
    return new Observable((observer) => {
      const i = new Image();
      i.onload = function () {
        observer.next({ width: i.naturalWidth, height: i.naturalHeight });
      };

      i.onerror = function () {
        observer.error('Failed to get image dimensions.');
      };

      i.src = file;
    });
  }

  static calculateDimensions(
    dimensions: { width: number; height: number },
    maxSize: number,
  ): { width: number; height: number } {
    let width = dimensions.width;
    let height = dimensions.height;

    // Ratio used to determine if the image s horizontal or vertical
    const ratio = width / height;
    // Horizontal image
    if (ratio > 1) {
      if (width < maxSize) {
        return dimensions;
      }
      width = maxSize;
      height = Math.trunc(width / ratio);
      // Vertical image
    } else {
      if (height < maxSize) {
        return dimensions;
      }
      height = maxSize;
      width = Math.trunc(height * ratio);
    }
    return { width: width, height: height };
  }
}
